import { render, staticRenderFns } from "./book-card-mini.vue?vue&type=template&id=17beeaa4&"
import script from "./book-card-mini.vue?vue&type=script&lang=js&"
export * from "./book-card-mini.vue?vue&type=script&lang=js&"
import style0 from "./book-card-mini.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports